
import moment from 'moment'
import LoadFilters from '~/components/loads/LoadFilters.vue';
import LoadListItem from '../../components/loads/loadListItem.vue';
import util from '../../util/Util';
import { CARRIER, DEFAULT_RADIUS } from '../../util/constants';
import MoonLoader from 'vue-spinner/src/MoonLoader.vue';
import { UserManager } from 'oidc-client';
import { configs } from '../../config/config.keys';
import configurations from '~/plugins/oidc-client-config.js';

export default {
  components: {
    LoadFilters,
    LoadListItem,
    MoonLoader
  },
  data() {
    return {
      timer: null,
      searchLoadTimer: null,
      userMgr: null,
      isShipper: false,
      currentPage: parseInt(this.$route.query.currentPage) || 1,
      tabIndex: parseInt(this.$route.query.tabIndex) || 0,
      pageSize: 20,
      isLoading: false,
      totalDistance: 0,
      showTotalDistance: false,
      showTotalNumer: false,
      loadList: {
        result: [],
        count: 0
      },
      favouritesList: [],
      defaultFilterFromQueryParam: {
        from: null,
        to: null,
        fromRadius: null,
        toRadius: null,
        radiusCommon: DEFAULT_RADIUS,
        pickupState: null,
        deliveryState: null,
        customerType: null,
        category: null,
        dateType: null,
        fromDate: null,
        toDate: null,
        selectedDateType: null,
        keyword: '',
      },
      selectedTab: this.$route.query.selectedTab || 'region',
      sortBy: this.$route.query.sortBy || 'Newest',
      filterBy: parseInt(this.$route.query.filterBy) || 0,
      filterByLabel: this.$route.query.filterByLabel || 'All',
      filterByOptions: {
        'All': 0,
        'Accepting Quotes': 2,
        'Expired': 6,
        'Draft': 1,
        'Withdrawn': 5
      },
      filters: {
        pickup: {
          suburb: '',
          regionPrefixes: [],
          radius: null
        },
        delivery: {
          suburb: '',
          regionPrefixes: [],
          radius: null
        },
        radiusCommon: DEFAULT_RADIUS,
        pickupState: null,
        deliveryState: null,
        customerType: null,
        cargoCategory: null,
        loadDate: {
          dateType: null,
          fromDate: null,
          toDate: null,
          selectedDateType: null
        },
        loadTypes: {
          isUrgent: false,
          isReadyNow: false,
          isRecent: false,
        },
        keyword: '',
      },
      formattedFilters: {},
      DEFAULT_RADIUS,
      routeValidation: {
        fromRequired: false,
        toRequired: false,
        radiusRequired: false,
      },
      directionsService: null,
      map: null,
      polyline: null,
      currentRoute: '',
      CARRIER,
    }
  },
  async fetch() {
    if (!process.server) {
      this.isLoading = true
      // Check query code to get user token when user login to create load
      if (Object.keys(this.$route.query).length !== 0 && this.$route.query.code !== undefined) {
        this.isShipper = true
        this.userMgr = new UserManager(configurations.authConfigLoadLogin)
        const user = await this.userMgr.signinRedirectCallback()
        if (user) {
          this.$store.commit('user/setToken', user.access_token);
          this.$store.commit('user/setTokenType', user.token_type);
          localStorage.setItem('token', user.access_token)
          localStorage.setItem('id_token', user.id_token)
          this.$store.dispatch('user/getUserDetails');
          this.$store.dispatch('user/getProfileDetails');
          this.isLoading = false
        } else {
          this.isLoading = false
          this.search(this.currentPage);
        }
      } else {
        this.isShipper = this.currentUser && this.currentUser.role === 'Shipper'
        setTimeout(() => {
          this.search(this.currentPage);
        }, 1000)
      }
    }
  },
  head() {
    return !window.google
      ? {
        title: 'Browse Freight Loads Board | UTransport',
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: 'Looking to grow your business? Join the Australias largest marketplace and find hundreds of loads today! Get started for free and start earning.'
          }
        ],
        script: [
          {
            hid: 'maps-googleapis',
            defer: true,
            src: process.env.G_MAP_URL || 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCxOuvD0HTiPDNYtwO88wyRVYXkSxAm3Cs&libraries=places'
          }
        ]
      }
      : {
        title: 'Load Boards Quotation Australia - Utransport',
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: 'Get competitive freight quotes for interstate shipments in Australia and access premium load boards. Streamline your logistics with our load board services.'
          }
        ],
      }

  },
  computed: {
    currentUser() {
      return this.$store.state.user.currentUser;
    },
    isFilterVisible() {
      return !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
    },
    popularRoutes() {
      return this.$store.state.lookup.popularRoutes;
    },
    formattedTotalDistance() {
      return this.totalDistance.toLocaleString()
    },
    formattedLeadingZeros() {
      let fullString = this.totalDistance.toString().padStart(8, '0').split('').reverse().join('')
      let commaSeparatedString = fullString.match(/.{1,3}/g).join(',').split('').reverse().join('')
      let index = 8;
      for (let i in commaSeparatedString) {
        if (!(commaSeparatedString[i] == '0' || commaSeparatedString[i] == ',')) {
          index = i;
          break;
        }
      }
      return (commaSeparatedString.slice(0, index))
    }

  },
  watch: {
    '$route.query'() {
      if (!(this.currentRoute.includes('loads-board') && this.$route.fullPath === '/loads-board')) {
        if (Object.keys(this.$route.query).length === 0) {
          this.resetFilters()
          this.searchLoads()
        }
        else {
          this.updateFromAndTo();
        }
      }
      this.currentRoute = this.$route.fullPath
    },
    currentUser: {
      handler() {
        if (this.currentUser) {
          if (this.currentUser.role === 'Shipper') {
            this.isShipper = true
          }
          else {
            this.isShipper = false
          }
        }
        else {
          this.isShipper = false
        }
        setTimeout(() => {
          this.search(this.currentPage);
        }, 1000)
      },
      deep: true,
    }
  },
  mounted() {
  },
  created() {
    this.getTotalDistanceVisibility()
    this.updateFromAndTo();
    if (!process.server) {
      this.userMgr = new UserManager(configurations.authConfigLogin);
    }
    this.getTotalDistance()
  },
  methods: {
    filterChanged(value) {
      this.filters = value
      this.formattedFilters = {
        ...(value.pickup?.suburb?.suburb && { from: value.pickup?.suburb?.suburb }),
        ...(value.pickup?.radius && { fromRadius: value.pickup?.radius }),
        ...(value.delivery?.suburb?.suburb && { to: value.delivery?.suburb?.suburb }),
        ...(value.delivery?.radius && { toRadius: value.delivery?.radius }),
        ...(value.radiusCommon && { radiusCommon: value.radiusCommon }),
        ...(value.pickupState?.length > 0 && { pickupState: value.pickupState }),
        ...(value.deliveryState?.length > 0 && { deliveryState: value.deliveryState }),
        ...(value.customerType && { customerType: value.customerType }),
        ...(value.cargoCategory?.length > 0 && { category: value.cargoCategory }),
        ...(value.loadDate?.dateType && { dateType: parseInt(value.loadDate?.dateType) }),
        ...(value.loadDate?.fromDate && { fromDate: value.loadDate?.fromDate }),
        ...(value.loadDate?.toDate && { toDate: value.loadDate?.toDate }),
        ...(value.loadDate?.selectedDateType && { selectedDateType: value.loadDate?.selectedDateType }),
        ...(value.loadTypes?.isUrgent && { isUrgent: value.loadTypes?.isUrgent }),
        ...(value.loadTypes?.isReadyNow && { isReadyNow: value.loadTypes?.isReadyNow }),
        ...(value.loadTypes?.isRecent && { isRecent: value.loadTypes?.isRecent }),
        ...(value.keyword && { keyword: value.keyword }),
      }
      if ((value.pickup.suburb || value.delivery.suburb) && this.selectedTab === 'route') {
        this.routeValidation.fromRequired = true;
        this.routeValidation.toRequired = true;
        this.routeValidation.radiusRequired = true;
      }
      else {
        this.routeValidation.fromRequired = false;
        this.routeValidation.toRequired = false;
        this.routeValidation.radiusRequired = false;
      }
    },
    resetFilters() {
      this.$router.push({ query: {} })?.catch(() => { })
      this.defaultFilterFromQueryParam = {
        from: null,
        to: null,
        fromRadius: null,
        toRadius: null,
        radiusCommon: DEFAULT_RADIUS,
        pickupState: null,
        deliveryState: null,
        customerType: null,
        category: null,
        dateType: null,
        fromDate: null,
        toDate: null,
        selectedDateType: null,
        keyword: '',
      }
      const tempFilters = {
        pickup: {
          regionPrefixes: [],
          suburb: '',
          radius: null
        },
        delivery: {
          regionPrefixes: [],
          suburb: '',
          radius: null
        },
        radiusCommon: DEFAULT_RADIUS,
        pickupState: null,
        deliveryState: null,
        customerType: null,
        cargoCategory: null,
        loadDate: {
          dateType: null,
          fromDate: null,
          toDate: null,
          selectedDateType: null
        },
        loadTypes: {
          isUrgent: false,
          isReadyNow: false,
          isRecent: false,
        },
        keyword: ''
      }
      this.filters = tempFilters
      this.filterChanged(tempFilters)

    },
    setTab(tab, index) {
      this.selectedTab = tab;
      this.tabIndex = index;
      this.currentPage = 1
      this.resetFilters()
      this.search()
    },
    sortChanged(value) {
      this.sortBy = value
      this.searchLoads()
    },
    updateFromAndTo() {
      if (this.$route.query.currentPage) {
        this.currentPage = parseInt(this.$route.query.currentPage)
      }
      if (this.$route.query.selectedTab) {
        this.selectedTab = this.$route.query.selectedTab
      }

      if (this.$route.query.tabIndex) {
        this.tabIndex = parseInt(this.$route.query.tabIndex)
      }

      if (this.$route.query.sortBy) {
        this.sortBy = this.$route.query.sortBy
      }

      if (this.$route.query.filterBy) {
        this.filterBy = parseInt(this.$route.query.filterBy)
      }

      if (this.$route.query.filterByLabel) {
        this.filterByLabel = this.$route.query.filterByLabel
      }

      this.$nextTick(() => {
        const from = this.$route.query.from !== undefined ? this.popularRoutes.filter(x => x.from.toLowerCase() === this.$route.query.from) : []
        const to = this.$route.query.to !== undefined ? this.popularRoutes.filter(x => x.to.toLowerCase() === this.$route.query.to) : []

        let fromValue = null;
        let toValue = null;
        if (from.length > 0) {
          fromValue = from[0].fromFilter;
        } else {
          fromValue = this.$route.query.from
        }

        if (to.length > 0) {
          toValue = to[0].toFilter;
        } else {
          toValue = this.$route.query.to
        }
        this.defaultFilterFromQueryParam = {

          ...this.$route.query,
          from: fromValue || null,
          to: toValue || null,
        }

      })
      this.pageLoadSearch()

    },
    pageLoadSearch() {
      this.isLoading = true;
      // this.filterChanged(value);
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(() => {
        this.search(this.currentPage);
      }, 400);
    },
    filterByChanged(value) {
      this.filterByLabel = value
      this.filterBy = this.filterByOptions[value]
      this.searchLoads()
    },
    isIncompleteUser() {
      if (!this.currentUser) {
        return false;
      } else if (this.currentUser && this.currentUser.role == CARRIER && !this.currentUser.emailConfirmed) {
        this.showEmailModal()
        return true;
      } else {
        return false;
      }
    },
    pageChange(e) {
      this.currentPage = e
      this.search(e)
    },
    async setLoadListWithFav(loads) {
      const data = {
        user: this.$store.state.user
      }
      let favList = []
      this.loadList = {
        result: [],
        count: 0
      }
      await this.$store.dispatch('favourites/getFavouriteListIdsByUser', data).then((res) => {
        if (res.isSuccess) {

          if (res.result?.favouriteList?.length > 0) {
            favList = res.result?.favouriteList?.map(fav => {
              return fav.loadId
            });
            let tempLoadList = []
            tempLoadList = loads?.result.length > 0 && loads?.result?.map(load => {
              if (favList?.includes(load.load.id)) {
                load = { ...load, isFav: true }
              }
              return load
            });
            this.loadList.result = tempLoadList
          }
          else {
            this.loadList.result = loads.result || []
          }
          window.scrollTo(0, 0);
          this.loadList.count = loads.count
          this.isLoading = false
        }
      });
    },
    showSignUpModal() {
      const msgBody = 'Utransport provides free access to carriers and shippers, Sign in or Register to view more'
      this.$bvModal.msgBoxConfirm(msgBody, {
        title: 'Join Utransport to see more',
        cancelVariant: 'primary',
        okVariant: 'secondary',
        okTitle: 'Register',
        cancelTitle: 'Sign In',
        hideHeaderClose: false,
        centered: true,
        contentClass: 'quote-modal',
        bodyClass: 'form-componant',
        noCloseOnBackdrop: true
      })
        .then(value => {
          if (value) {
            this.signUp();
          }
          else if (value == false) {
            this.login();
          }
        })
    },
    showSubscribeModal() {
      const msgBody = 'Please subscribe to gain full functionality to your Utransport portal.'
      this.$bvModal.msgBoxOk(msgBody, {
        title: 'Subscribe to see more',
        cancelVariant: 'primary',
        okVariant: 'secondary',
        okTitle: 'Subscribe',
        hideHeaderClose: false,
        centered: true,
        contentClass: 'quote-modal',
        bodyClass: 'form-componant',
        noCloseOnBackdrop: true
      })
        .then(value => {
          if (value) {
            this.redirectToSubscription();
          }
        })
    },
    showEmailModal() {
      const msgBody = 'Please verify your email address to gain full functionality to your Utransport portal. You may click the link on the page to resend the email again.'
      this.$bvModal.msgBoxOk(msgBody, {
        title: 'Verify email to see more',
        cancelVariant: 'primary',
        okVariant: 'secondary',
        okTitle: 'Close',
        hideHeaderClose: true,
        centered: true,
        contentClass: 'quote-modal',
        bodyClass: 'form-componant',
        noCloseOnBackdrop: true
      })
    },
    login() {
      return this.userMgr.signinRedirect({ state: 'dskjqmoiqQdjnJHOnGn' });
    },
    signUp() {
      window.location.href =
        configs.signupUrl;
    },
    redirectToSubscription() {
      this.$router.push({
        path: '/settings/subscription'
      });
    },
    isValid() {
      return !(this.selectedTab === 'route' && ((this.routeValidation.fromRequired && !this.filters.pickup.suburb) || (this.routeValidation.toRequired && !this.filters.delivery.suburb) || (this.routeValidation.radiusRequired && !(this.filters.radiusCommon && this.filters.radiusCommon >= 10))))
    },
    setQueryParams() {
      let query = {}

      if (this.selectedTab) {
        query['selectedTab'] = this.selectedTab
      }
      if (this.tabIndex) {
        query['tabIndex'] = this.tabIndex
      }
      if (this.currentPage) {
        query['currentPage'] = this.currentPage
      }
      if (this.sortBy) {
        query['sortBy'] = this.sortBy
      }
      if (this.filterBy) {
        query['filterBy'] = this.filterBy
      }
      if (this.filterByLabel) {
        query['filterByLabel'] = this.filterByLabel
      }
      if (this.filters.pickup.suburb) {
        query['from'] = this.filters.pickup.suburb.suburb
      }

      if (this.filters.delivery.suburb) {
        query['to'] = this.filters.delivery.suburb.suburb
      }

      if (this.filters.cargoCategory && this.filters.cargoCategory.length > 0) {
        query['category'] = this.filters.cargoCategory
      }
      if (this.filters?.pickup?.radius) {
        query['fromRadius'] = this.filters?.pickup?.radius
      }
      if (this.filters.delivery.radius) {
        query['toRadius'] = this.filters.delivery.radius
      }
      if (this.filters.radiusCommon) {
        query['radiusCommon'] = this.filters.radiusCommon
      }
      if (this.filters.pickupState && this.filters.pickupState.length > 0) {
        query['pickupState'] = this.filters.pickupState
      }
      if (this.filters.deliveryState && this.filters.deliveryState.length > 0) {
        query['deliveryState'] = this.filters.deliveryState
      }
      if (this.filters.customerType) {
        query['customerType'] = this.filters.customerType
      }
      if (this.filters.loadDate.dateType) {
        query['dateType'] = this.filters.loadDate.dateType
      }
      if (this.filters.loadDate.fromDate) {
        query['fromDate'] = this.filters.loadDate.fromDate
      }
      if (this.filters.loadDate.toDate) {
        query['toDate'] = this.filters.loadDate.toDate
      }
      if (this.filters.loadDate.selectedDateType) {
        query['selectedDateType'] = this.filters.loadDate.selectedDateType
      }
      if (this.filters.loadTypes.isUrgent) {
        query['isUrgent'] = this.filters.loadTypes.isUrgent
      }
      if (this.filters.loadTypes.isReadyNow) {
        query['isReadyNow'] = this.filters.loadTypes.isReadyNow
      }
      if (this.filters.loadTypes.isRecent) {
        query['isRecent'] = this.filters.loadTypes.isRecent
      }
      if (this.filters.keyword) {
        query['keyword'] = this.filters.keyword
      }
      this.$router.push({ query })?.catch(() => { })
    },
    searchLoads() {
      this.currentPage = 1
      this.search(1)
    },
    async search(currentPage = 1) {
      if (this.isValid()) {
        this.isLoading = true
        this.setQueryParams()

        const payload = {
          filters: {}
        }
        if (this.currentUser && this.currentUser.role === 'Shipper') {
          payload.user = this.$store.state.user

          payload.filters = {
            shipperFilter: {
              filterBy: this.filterBy
            },
            orderBy: this.sortBy.toLowerCase(),
            pageNumber: currentPage,
            pageSize: this.pageSize
          }
        }
        else {
          if (this.selectedTab === 'region') {
            const PickupRegionPrefixes = util.getPrefixes(this.filters.pickup.regionPrefixes);
            const CollectionRegionPrefixes = util.getPrefixes(this.filters.delivery.regionPrefixes);

            payload.filters = {
              regionFilter: {
                pickup: this.filters.pickup.suburb ? this.filters.pickup.suburb.suburb : '',
                delivery: this.filters.delivery.suburb ? this.filters.delivery.suburb.suburb : '',
                pickupLat: this.filters.pickup.suburb ? this.filters.pickup.suburb.lat : 0,
                pickupLong: this.filters.pickup.suburb ? this.filters.pickup.suburb.lng : 0,
                deliveryLat: this.filters.delivery.suburb ? this.filters.delivery.suburb.lat : 0,
                deliveryLong: this.filters.delivery.suburb ? this.filters.delivery.suburb.lng : 0,
                pickupRadius: this.filters.pickup.suburb ? (this.filters.pickup.radius ? parseInt(this.filters.pickup.radius) : this.DEFAULT_RADIUS) : 0,
                deliveryRadius: this.filters.delivery.suburb ? (this.filters.delivery.radius ? parseInt(this.filters.delivery.radius) : this.DEFAULT_RADIUS) : 0,
                customerType: this.filters.customerType ? this.filters.customerType : 0,
                loadDateType: this.filters.loadDate.dateType ? parseInt(this.filters.loadDate.dateType) : 0,
                category: this.filters.cargoCategory ? this.filters.cargoCategory : [],
                keyword: this.filters.keyword ? this.filters.keyword : '',
                loadCollectionStartDate: this.filters.loadDate.fromDate ? util.formatDateToISO(this.filters.loadDate.fromDate) : util.formatDateToISO(moment().subtract(100, 'years')),
                loadCollectionEndDate: this.filters.loadDate.toDate ? util.formatDateToISO(this.filters.loadDate.toDate) : util.formatDateToISO(moment().add(100, 'years')),
                loadDeliveryStartDate: this.filters.loadDate.fromDate ? util.formatDateToISO(this.filters.loadDate.fromDate) : util.formatDateToISO(moment().subtract(100, 'years')),
                loadDeliveryEndDate: this.filters.loadDate.toDate ? util.formatDateToISO(this.filters.loadDate.toDate) : util.formatDateToISO(moment().add(100, 'years')),
                pickupRegionPrefixes: PickupRegionPrefixes,
                deliveryRegionPrefixes: CollectionRegionPrefixes
              },
              isUrgent: this.filters.loadTypes?.isUrgent?.toString() == 'true',
              isReadyNow: this.filters.loadTypes?.isReadyNow?.toString() == 'true',
              isRecent: this.filters.loadTypes?.isRecent?.toString() == 'true',
              orderBy: this.sortBy.toLowerCase(),
              pageNumber: currentPage,
              pageSize: this.pageSize
            }
          }
          else if (this.selectedTab === 'state') {
            payload.filters = {
              stateFilter: {
                pickupState: this.filters.pickupState ? this.filters.pickupState : [],
                deliveryState: this.filters.deliveryState ? this.filters.deliveryState : [],
                customerType: this.filters.customerType ? this.filters.customerType : 0,
                loadDateType: this.filters.loadDate.dateType ? parseInt(this.filters.loadDate.dateType) : 0,
                category: this.filters.cargoCategory ? this.filters.cargoCategory : [],
                keyword: this.filters.keyword ? this.filters.keyword : '',
                loadCollectionStartDate: this.filters.loadDate.fromDate ? util.formatDateToISO(this.filters.loadDate.fromDate) : util.formatDateToISO(moment().subtract(100, 'years')),
                loadCollectionEndDate: this.filters.loadDate.toDate ? util.formatDateToISO(this.filters.loadDate.toDate) : util.formatDateToISO(moment().add(100, 'years')),
                loadDeliveryStartDate: this.filters.loadDate.fromDate ? util.formatDateToISO(this.filters.loadDate.fromDate) : util.formatDateToISO(moment().subtract(100, 'years')),
                loadDeliveryEndDate: this.filters.loadDate.toDate ? util.formatDateToISO(this.filters.loadDate.toDate) : util.formatDateToISO(moment().add(100, 'years')),
              },
              isUrgent: this.filters.loadTypes?.isUrgent?.toString() == 'true',
              isReadyNow: this.filters.loadTypes?.isReadyNow?.toString() == 'true',
              isRecent: this.filters.loadTypes?.isRecent?.toString() == 'true',
              orderBy: this.sortBy.toLowerCase(),
              pageNumber: currentPage,
              pageSize: this.pageSize
            }
          }
          else if (this.selectedTab === 'route') {
            let wayPoints = []
            if (this.filters.pickup.suburb && this.filters.delivery.suburb) {
              wayPoints = await this.getWayPoints();
            }
            payload.filters = {
              routeFilter: {
                from: this.filters.pickup.suburb ? this.filters.pickup.suburb.suburb : '',
                to: this.filters.delivery.suburb ? this.filters.delivery.suburb.suburb : '',
                fromLat: this.filters.pickup.suburb ? this.filters.pickup.suburb.lat : 0,
                fromLong: this.filters.pickup.suburb ? this.filters.pickup.suburb.lng : 0,
                toLat: this.filters.delivery.suburb ? this.filters.delivery.suburb.lat : 0,
                toLong: this.filters.delivery.suburb ? this.filters.delivery.suburb.lng : 0,
                radius: this.filters.radiusCommon ? parseInt(this.filters.radiusCommon) : this.DEFAULT_RADIUS,
                customerType: this.filters.customerType ? this.filters.customerType : 0,
                loadDateType: this.filters.loadDate.dateType ? parseInt(this.filters.loadDate.dateType) : 0,
                waypoints: wayPoints,
                category: this.filters.cargoCategory ? this.filters.cargoCategory : [],
                keyword: this.filters.keyword ? this.filters.keyword : '',
                loadCollectionStartDate: this.filters.loadDate.fromDate ? util.formatDateToISO(this.filters.loadDate.fromDate) : util.formatDateToISO(moment().subtract(100, 'years')),
                loadCollectionEndDate: this.filters.loadDate.toDate ? util.formatDateToISO(this.filters.loadDate.toDate) : util.formatDateToISO(moment().add(100, 'years')),
                loadDeliveryStartDate: this.filters.loadDate.fromDate ? util.formatDateToISO(this.filters.loadDate.fromDate) : util.formatDateToISO(moment().subtract(100, 'years')),
                loadDeliveryEndDate: this.filters.loadDate.toDate ? util.formatDateToISO(this.filters.loadDate.toDate) : util.formatDateToISO(moment().add(100, 'years')),
              },
              isUrgent: this.filters.loadTypes?.isUrgent?.toString() == 'true',
              isReadyNow: this.filters.loadTypes?.isReadyNow?.toString() == 'true',
              isRecent: this.filters.loadTypes?.isRecent?.toString() == 'true',
              orderBy: this.sortBy.toLowerCase(),
              pageNumber: currentPage,
              pageSize: this.pageSize
            }
          }
        }
        window.clearTimeout(this.searchLoadTimer);
        this.searchLoadTimer = window.setTimeout(() => {
          this.$store.dispatch('loads/getLoadsListWithfilters', payload).then((res) => {
            if (res.isSuccess) {
              if (this.currentUser && this.currentUser.role == CARRIER) {
                this.setLoadListWithFav(res)
              }
              else {
                window.scrollTo(0, 0);
                this.loadList.result = res.result || []
                this.loadList.count = res.count
                this.isLoading = false
              }
            } else {
              this.$toast.error('Failed to Get Loads - Contact support@utransport.com.au').goAway(5000)
              this.isLoading = false
            }
          })
        }, 800);
      } else {
        this.isLoading = false
      }
    },

    async getWayPoints() {
      return new Promise((resolve) => {
        var directionsService = new window.google.maps.DirectionsService;
        var directionsDisplay = new window.google.maps.DirectionsRenderer;
        this.polyline = new window.google.maps.Polyline({
          path: []
        });

        const points = this.calculateAndDisplayRoute(directionsService, directionsDisplay);
        resolve(points)
      })
    },

    async calculateAndDisplayRoute(directionsService, directionsDisplay) {
      return new Promise((resolve) => {
        const that = this;
        directionsService.route({
          origin: new window.google.maps.LatLng(this.filters.pickup.suburb.lat, this.filters.pickup.suburb.lng),
          destination: new window.google.maps.LatLng(this.filters.delivery.suburb.lat, this.filters.delivery.suburb.lng),
          travelMode: 'DRIVING'
        }).then((response) => {
          if (response.status == window.google.maps.DirectionsStatus.OK) {
            this.polyline.setPath([]);
            var bounds = new window.google.maps.LatLngBounds();
            const startLocation = new Object();
            const endLocation = new Object();
            directionsDisplay.setDirections(response);
            var legs = response.routes[0].legs;
            for (let i = 0; i < legs.length; i++) {
              if (i == 0) {
                startLocation.latlng = legs[i].start_location;
                startLocation.address = legs[i].start_address;
              }
              endLocation.latlng = legs[i].end_location;
              endLocation.address = legs[i].end_address;
              var steps = legs[i].steps;
              for (let j = 0; j < steps.length; j++) {
                var nextSegment = steps[j].path;
                for (let k = 0; k < nextSegment.length; k++) {
                  this.polyline.getPath().push(nextSegment[k]);
                  bounds.extend(nextSegment[k]);
                }
              }
            }

            window.google.maps.Polyline.prototype.GetPointsAtDistance = function (metres) {
              var next = metres;
              //Including From lat lang to the way points
              var points = [{ lat: that.filters.pickup.suburb.lat, lng: that.filters.pickup.suburb.lng }];
              // special cases
              if (metres <= 0) return points;
              var dist = 0;
              var olddist = 0;
              for (var i = 1;
                (i < this.getPath().getLength()); i++) {
                olddist = dist;
                dist += window.google.maps.geometry.spherical.computeDistanceBetween(this.getPath().getAt(i), this.getPath().getAt(i - 1));

                while (dist > next) {
                  var p1 = this.getPath().getAt(i - 1);
                  var p2 = this.getPath().getAt(i);

                  var m = (next - olddist) / (dist - olddist);
                  points.push({ lat: (p1.lat() + (p2.lat() - p1.lat()) * m), lng: (p1.lng() + (p2.lng() - p1.lng()) * m) });
                  next += metres;
                }
              }
              //Including To lat lang to the way points
              points.push({ lat: that.filters.delivery.suburb.lat, lng: that.filters.delivery.suburb.lng })
              return points;
            }
            var points = this.polyline.GetPointsAtDistance((this.filters.radiusCommon || this.DEFAULT_RADIUS) * 1000);
            resolve(points)
          } else {
            resolve([])
          }
        })
      });
    },
    isSortActive(value) {
      return this.sortBy === value
    },
    isFilterActive(value) {
      return this.filterByLabel === value
    },
    getTotalDistance() {
      this.$store
        .dispatch('loads/getTotalDistance')
        .then((res) => {
          if (res.isSuccess) {
            this.totalDistance = res.result;
          }
        });
    },
    getTotalDistanceVisibility() {
      this.$store
        .dispatch('loads/getTotalDistanceVisibility')
        .then((res) => {
          if (res.isSuccess) {
            this.showTotalDistance = res.result.loadDistanceVisibility;
            this.showTotalNumer = res.result.totalLoadVisibility;
          }
        });
    },
    viewPageInNewTab(url) {
      const routeData = this.$router.resolve({ path: url});
      window.open(routeData.href, '_blank');
    },
  }
}
